(function(){
  if (window.__bkSet) return;
  window.__bkSet = 1;
  function show(set) {
    document.querySelectorAll('.bk-set ul').forEach(function (u) { u.hidden = u.getAttribute('data-set') !== set; });
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.type === 'radio' && t.name === 'Zestaw') show(/V2/.test(t.value) ? '2' : '1');
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-bk-pick]');
    if (!a) return;
    e.preventDefault();
    var r = document.querySelector('input[name="Zestaw"][value="' + a.getAttribute('data-bk-pick') + '"]');
    if (r && !r.checked) r.click();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
})();
